module.exports = __webpack_public_path__ + "img/users.48bd99d9.svg";